export const WHATSAPP_NUMBER = "6281331131286";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const CONTACT_EMAIL = "info@ansenindo.com";
export const COMPANY = {
  name: "ANSEN Indonesia",
  legalEntity: "CV Amanah Sukses Sentosa",
  nib: "0306260105753",
  npwp: "1000000009860081",
};

export const CATEGORIES = [
  { id: "agriculture", image: "/images/spices.webp", products: ["coffee", "areca"] },
  { id: "wood", image: "/images/wood.jpg", products: ["dowel"] },
  { id: "biomass", image: "/images/energi.jpg", products: ["pellets"] },
];

export const PRODUCTS = {
  coffee: {
    id: "coffee",
    category: "agriculture",
    image: "/images/green-bean-robusta.jpg",
    specs: [
      { key: "grade", value: "Grade 1 (Specialty) / Grade 2–4 (SNI 01-2907-2008)" },
      { key: "moisture", value: "Max 12%" },
      { key: "packaging", value: "30 / 60 kg jute bags + GrainPro liner" },
      { key: "moq", value: "1 MT (LCL)" },
      { key: "hsCode", value: "0901.11" },
    ],
  },
  areca: {
    id: "areca",
    category: "agriculture",
    image: "/images/Pinang.jpg",
    specs: [
      { key: "grade", value: "Whole / Split · 80–95% ripeness" },
      { key: "moisture", value: "Max 10%" },
      { key: "packaging", value: "25 / 50 kg PP woven bags" },
      { key: "moq", value: "5 MT" },
      { key: "hsCode", value: "0802.80" },
    ],
  },
  dowel: {
    id: "dowel",
    category: "wood",
    image: "/images/dowel-rods.jpg",
    specs: [
      { key: "grade", value: "A / B (furniture grade)" },
      { key: "size", value: "Ø 6–30 mm × 300–2,400 mm" },
      { key: "moisture", value: "8–12% (kiln dried)" },
      { key: "packaging", value: "Bundles / cartons, containerized" },
      { key: "moq", value: "1 × 20 ft container" },
      { key: "hsCode", value: "4409.29" },
    ],
  },
  pellets: {
    id: "pellets",
    category: "biomass",
    image: "/images/pellets.jpg",
    specs: [
      { key: "grade", value: "Premium (ENplus A1-comparable)" },
      { key: "size", value: "Ø 6–8 mm" },
      { key: "moisture", value: "≤ 10%" },
      { key: "ash", value: "≤ 2%" },
      { key: "calorific", value: "4,200–4,800 kcal/kg" },
      { key: "packaging", value: "15 kg bags / 1-ton jumbo bags / bulk" },
      { key: "moq", value: "24 MT (1 × 20 ft container)" },
      { key: "hsCode", value: "4401.31" },
    ],
  },
};

export const PRODUCT_IDS = Object.keys(PRODUCTS);

export const ARTICLES = [
  { id: "a3", tag: "areca", image: "/images/areca.jpg", date: "2026-06-10", minutes: 5 },
  { id: "a2", tag: "pellets", image: "/images/pellets.jpg", date: "2026-05-28", minutes: 4 },
  { id: "a1", tag: "coffee", image: "/images/coffee.jpg", date: "2026-05-12", minutes: 4 },
];
